var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Directive, Output, EventEmitter, ElementRef } from "@angular/core";
/**
 * Created by Vasilenko on 28-Nov-16.
 */
export var HammerGesturesDirective = (function () {
    function HammerGesturesDirective(el) {
        this.el = el;
        this.onGesture = new EventEmitter();
    }
    HammerGesturesDirective.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!HammerGesturesDirective.hammerInitialized) {
            var hammertime = new Hammer(this.el.nativeElement);
            hammertime.get('swipe').set({ direction: Hammer.DIRECTION_ALL });
            hammertime.on("swipeup", function (ev) {
                _this.onGesture.emit("swipeup");
            });
            hammertime.on("swipedown", function (ev) {
                _this.onGesture.emit("swipedown");
            });
            hammertime.on("swipeleft", function (ev) {
                _this.onGesture.emit("swipeleft");
            });
            hammertime.on("swiperight", function (ev) {
                _this.onGesture.emit("swiperight");
            });
            hammertime.on("tap", function (ev) {
                _this.onGesture.emit("tap");
            });
            HammerGesturesDirective.hammerInitialized = true;
        }
    };
    HammerGesturesDirective.hammerInitialized = false;
    __decorate([
        Output(), 
        __metadata('design:type', Object)
    ], HammerGesturesDirective.prototype, "onGesture", void 0);
    HammerGesturesDirective = __decorate([
        Directive({
            selector: '[hammer-gestures]'
        }), 
        __metadata('design:paramtypes', [ElementRef])
    ], HammerGesturesDirective);
    return HammerGesturesDirective;
}());
//# sourceMappingURL=hammer-gestures.directive.js.map